import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    TgGridModule,
    TgIconBasicArrowRightModule,
    TgIconStopModule,
    TgIconBasicTickFramedModule,
    TgSelectModule,
    TgInputModule,
    TgRackModule,
    TgBoxes2Module
} from '@trademe/tangram';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule } from '@angular/forms';
import { PropertyInformationSectionComponent } from './property-information-section.component';
import { TmDateComponent } from 'libs/trademe-core-ui/src/lib/tm-date/tm-date.component';
import { PropertyRentalAvailabilitySectionModule } from '../../residential-for-rent/property-rental-availability-section/property-rental-availability-section.module';
import { PropertyRentalDetailsSectionModule } from '../../residential-for-rent/property-rental-details-section/property-rental-details-section.module';
import { PropertyFeatureSectionModule } from '../property-features-section/property-features-section.module';
import { DraftValidationModule } from '@classifieds-sell/shared';
import { PropertyInformationNoticeModule } from '../../../components/property-information-notice/property-information-notice.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgIconBasicArrowRightModule,
        TgIconStopModule,
        TgIconBasicTickFramedModule,
        TgGridModule,
        TgSelectModule,
        TgInputModule,
        TgRackModule,
        LayoutModule,
        PropertyInformationNoticeModule,
        PropertyRentalAvailabilitySectionModule,
        PropertyRentalDetailsSectionModule,
        PropertyFeatureSectionModule,
        DraftValidationModule,
        TgBoxes2Module
    ],
    declarations: [PropertyInformationSectionComponent],
    providers: [TmDateComponent],
    exports: [PropertyInformationSectionComponent]
})
export class PropertyInformationSectionModule {}
